import { Container } from '@/components/Containers/Container';
import { DataGenerator } from '@/components/DataGenerator';
import { useSession } from '@/hooks/useSession';
import { createGenStore } from '@/store/gen';
import { queries } from '@/utils/queryOptions';
import { Button } from '@frontend/ui/components/button';
import { createFileRoute } from '@tanstack/react-router';
import { add, endOfDay, startOfDay } from 'date-fns';

export const Route = createFileRoute('/_protected/generate')({
	component: RouteComponent,
	loader: async ({ context }) => {
		await context.queryClient.ensureQueryData(
			queries.generate['get-shift-employees'],
		);
	},
});

function RouteComponent() {
	const { isDemoSession, signIn } = useSession();

	if (isDemoSession) {
		return (
			<Container className="flex flex-col justify-center gap-6 items-center size-full">
				<h2 className="text-2xl text-muted-foreground">Unauthorized</h2>
				<Button variant="ghost" onClick={() => signIn?.()}>
					Login
				</Button>
			</Container>
		);
	}

	return (
		<DataGenerator
			store={createGenStore({
				range: {
					from: add(startOfDay(new Date()), { months: -6 }),
					to: endOfDay(new Date()),
				},
			})}
		/>
	);
}
